import React, { useEffect, useState, useGlobal } from "reactn";
import BaseModal from "./baseModal/BaseModal";
import { CONTENT_BLOCK, DROPDOWN, GET_HTML, STRING_INPUT } from "./baseModal/FieldTypes";
import { fetchConnectionsData } from "../../Caching";
import axios from "axios";
import Select from "react-dropdown-select";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";
import { toast } from "react-toastify";
import { validateEmail } from "./baseModal/validators";

const AppointmentInviteModal = ({ onClose }) => {
  const [global, setGlobal] = useGlobal();
  const [data, setData] = useState({ connections: [] });
  const [selectedUser, setSelectedUser] = useState(null);
  const [appt, setAppt] = useState([]);
  const [selectedappt, setSelectedAppt] = useState(null);
  const [email, setEmail] = useState("");

  const getInitialData = async () => {
    let connections = await fetchConnectionsData(global.organizationInfo.id);
    connections = connections.map((connection, i) => {
        return { ...connection, searchId: i }});
    setData({ connections });
    const res = await axios.get(`${process.env.REACT_APP_API}/partners/forms/list`);
    let ap = res.data.data.filter(item => item.form_name === "Appointments" && item.published === true);
    setAppt(ap.map((item) => {
        return {value: item.id, text: `Appointments (${item.form_sub_name})`}
    }));
  };
  const handleSubmit = async () => {
    let ep = `${process.env.REACT_APP_API}/partners/appointments/invite`;
    let res = await axios.post(ep, {email, id: selectedappt, slug: global.organizationInfo.slug});
    if (res.data.success) {
        toast.success("Email Sent Successfully");
        onClose();
    } else {
        toast.error("Email Sending Failed");
    }
  }

  const contactsHTML = () => {
    return (
      <>
        <div>
          <label
            htmlFor="displayName"
            style={{
              width: "25%",
              textAlign: "left",
              fontSize: "1.15rem",
              fontFamily: "futura-pt, sans-serif",
              fontWeight: "500",
              color: "#626262"
            }}
          >
            Contacts
          </label>
        </div>
        <div
          className="form-group"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 0
          }}
        >
          <div
            style={{
              height: "40px",
              width: "100%",
              fontSize: "0.93rem",
              fontFamily: "futura-pt, sans-serif",
              fontWeight: "400",
              color: "#797979"
            }}
          >
            <Select
              options={data.connections}
              // values={this.state.selectedLead}
              name={"selectedLead"}
              placeholder={"Select a Connection"}
              style={{
                height: "40px",
                width: "100%",
                fontSize: "0.93rem",
                fontFamily: "futura-pt, sans-serif",
                fontWeight: "400",
                color: "#797979",
                borderRadius: "4px"
              }}
              onChange={e => {
                if (!e || !e[0]) {
                    setSelectedUser(null);
                    setEmail(null);
                } else {
                    setSelectedUser(e.length === 0 ? null : e[0]);
                    setEmail(e.length === 0 ? null : e[0].email);
                }
              }}
              labelField={"displayName"}
              valueField={"searchId"}
              closeOnSelect={true}
              searchable={true}
              keepSelectedInList={true}
              dropdownHandle={true}
              clearable={true}
              searchBy={"displayName"}
            />
          </div>
        </div>{" "}
      </>
    );
  };
  useEffect(() => {
    getInitialData();
  }, []);
  const getBaseModalFields = () => {
    const contacts = {
        type: GET_HTML,
        data: {
            gethtml: contactsHTML
        }
    }
    const emailField = {
        type: STRING_INPUT,
        data: {
            name: "Email",
            required: true,
            // disabled: selectedUser ? true : false,
            value: email,
            handleChange: e => {
                setEmail(e.target.value);
            }
        },
        validators: {validateSubmit: validateEmail(email)}
    }
    const apptField = {
        type: DROPDOWN,
        data: {
            name: "Appointment",
            required: true,
            placeholder: "Select Form...",
            handleChange: e => {
                setSelectedAppt(e.target.value);
                // console.log(e.target.value);
            },
            choices: appt
        },
        validators: {validateSubmit: () => selectedappt !== null}
    }
    return [contacts, emailField, apptField];
  };
  const getBaseModalButtons = () => {
    const sendButton = {
        name: "Invite",
        handleClick: handleSubmit,
        buttonColour: BLUE_BUTTON,
        textColour: WHITE,
        validatorKey: "validateSubmit"
    }
    return [sendButton];
  };

  const getBaseModalProps = () => {
    return {
      title: "Appointment Invite",
      fields: getBaseModalFields(),
      buttons: getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "49vh",
      handleClose: () => onClose()
    };
  };
  return <BaseModal {...getBaseModalProps()} />;
};
export default AppointmentInviteModal;
